module.exports = __webpack_public_path__ + "static/media/number-item-9.7a77505a.png";